import React, { createContext, useContext, useState, useEffect } from "react";
import { useInventory } from "./InventoryContext";

const ConsumptionContext = createContext();

export const useConsumption = () => useContext(ConsumptionContext);

export const ConsumptionProvider = ({ children }) => {
  const { removeStock, inventories } = useInventory();

  // Load History from LocalStorage
  const [issuances, setIssuances] = useState(() => {
    try {
      const saved = localStorage.getItem("stockIssuances");
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("stockIssuances", JSON.stringify(issuances));
  }, [issuances]);

  // 🟢 CORE FUNCTION: Issue Material (With Safety Check)
  const issueMaterial = (data) => {
    // 1. Validate Stock again (Safety Check)
    const item = inventories.find(i => String(i.id) === String(data.materialId));
    if (!item) throw new Error("Item not found");

    // 2. Try to Deduct from Inventory (The Physical Move)
    // 🟢 Fix: We Capture the success result
    const success = removeStock(
        data.materialId, 
        data.quantity, 
        data.warehouseId, 
        data.bin, 
        `Issued to Project: ${data.projectName}`
    );

    // 🟢 Fix: If deduction failed (e.g. wrong bin), STOP HERE.
    if (!success) {
        throw new Error(`Failed to remove stock. Check if item exists in ${data.bin} of Warehouse.`);
    }

    // 3. Create the Official Issue Slip (Only if stock removal worked)
    const newSlip = {
        id: `MIS-${Date.now()}`, 
        date: new Date().toISOString(),
        costSheetId: data.costSheetId || null, 
        ...data, 
        status: "Issued",
        issuedBy: "Admin User" 
    };

    setIssuances(prev => [newSlip, ...prev]);
    return newSlip;
  };

  const getProjectConsumption = (projectId) => {
      return issuances.filter(i => String(i.projectId) === String(projectId));
  };

  const getCostSheetConsumption = (costSheetId) => {
      return issuances.filter(i => String(i.costSheetId) === String(costSheetId));
  };

  return (
    <ConsumptionContext.Provider value={{ issuances, issueMaterial, getProjectConsumption, getCostSheetConsumption }}>
      {children}
    </ConsumptionContext.Provider>
  );
};